import { ChartKey } from "@/types/chart";
import { ChartDataset } from "chart.js";

export const defaultColors = [
  "#0584C7",
  "#FF6384",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FF9F40",
];

type DatasetStyles = {
  line: Omit<ChartDataset<"line">, "data">;
  bar: Omit<ChartDataset<"bar">, "data">;
};

export const customizeDatasetStyles =
  ({ chartKey }: { chartKey: ChartKey }) =>
  ({ index }: { index: number }): DatasetStyles => {
    if (chartKey === "pe_stream") {
      const borderColor = [
        "#0669A1",
        "#6DD792",
        "#86EFAC",
        "#FDE047",
        "#EAB30A",
        "#FCA5A5",
        "#EF4444",
      ];

      const backgroundColor = [
        "transparent",
        "#6DD79230",
        "#86EFAC30",
        "#FDE04730",
        "#EAB30A30",
        "#FCA5A530",
        "#EF444430",
      ];

      const fill = [false, false, "-1", "-1", "-1", "-1", "-1"];

      return {
        line: {
          borderColor: borderColor[index],
          backgroundColor: backgroundColor[index],
          fill: fill[index],
          pointRadius: 0,
        },
        bar: {},
      };
    }
    if (chartKey === "eps_forecast" || chartKey === "revenue_forecast") {
      const borderColor = ["#0284C7", "transparent", "#16A34A", "transparent"];
      const backgroundColor = ["#0284C7", "#16A34A30", "#16A34A", "#16A34A30"];
      const fill = [false, "1", false, "1"];
      const pointBorderColor = ["#0284C7", "#16A34A", "#16A34A", "#16A34A"];

      return {
        line: {
          borderColor: borderColor[index],
          backgroundColor: backgroundColor[index],
          fill: fill[index],
          pointRadius: 5,
          pointBorderColor: pointBorderColor[index],
          pointHoverBorderColor: "#FFF",
          pointHoverBorderWidth: 2,
        },
        bar: {},
      };
    }
    return {
      line: {
        borderColor: defaultColors[index],
        backgroundColor: defaultColors[index],
        pointRadius: 3,
        pointBackgroundColor: defaultColors[index],
      },
      bar: {
        backgroundColor: defaultColors[index],
        borderWidth: 1,
      },
    };
  };
